module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.type == 'boolean' && _vm.validValue) ? _c('span', [_c('el-tag', {
    attrs: {
      "type": _vm.formatField() == 'Sim' ? 'success' : 'danger'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.formatField()) + "\n    ")])], 1) : ((_vm.type == 'date' || _vm.type == 'dateTime') && _vm.validValue()) ? _c('span', [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v("\n    " + _vm._s(_vm.formatField()) + "\n  ")]) : (_vm.type == 'time' && _vm.validValue()) ? _c('span', [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v("\n    " + _vm._s(_vm.formatField()) + "\n  ")]) : _c('span', [_vm._v("\n    " + _vm._s(_vm.formatField()) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3dd5850!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/FormatField.vue
// module id = 959
// module chunks = 2